<span class="badge badge-lg badge-outline-secondary ms-1">{{ params?.data?.instrumentType }}</span>
